
import SpendingInsightsScreen from "./SpendingInsightsScreen";
import SpendingInsightsDetailScreen from "./SpendingInsightsDetailScreen";
import SpendingInsightsAboutPendingScreen from "./SpendingInsightsAboutPendingScreen";
import SpendingInsightsFilterScreen from "./SpendingInsightsFilterScreen";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

const Stack = createStackNavigator();

export default function transactionsNavigationStack() {
      return (
            <>
                  <Stack.Screen
                        name="SpendingInsightsDetail"
                        component={SpendingInsightsDetailScreen}
                        options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                  />
                  <Stack.Screen
                        name="SpendingInsightsFilter"
                        component={SpendingInsightsFilterScreen}
                        options={{ headerShown: false }}
                  />
                  <Stack.Screen
                        name="SpendingInsightsAboutPending"
                        component={SpendingInsightsAboutPendingScreen}
                        options={{ headerShown: false }}
                  />
                  <Stack.Screen
                        name="SpendingInsights"
                        component={SpendingInsightsScreen}
                        options={{
                              title: null,
                              headerShown: false,
                              headerRight: () => <LaunchFilterButton />,
                        }}
                  />
            </>
      )
}